<template>
  <div class="InvoiceHistory">
    <div class="title">
      <h2 class="light">
        Invoice history
      </h2>
    </div>

    <div class="container">
      <div
        v-for="year of Object.keys(invoicesListByYear)"
        :key="year">
        <h4>{{ year }}</h4>
        <div class="panel">
          <table>
            <thead>
              <tr>
                <td>Period</td>
                <td>Amount</td>
                <td class="text-center">
                  Status
                </td>
                <td class="text-right">
                  Download
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="InvoiceItem"
                v-for="invoice of invoicesListByYear[year]"
                :key="invoice.id">
                <td class="text-bold">
                  {{ invoice.periodFrom | periodName }}
                </td>
                <td>{{ invoice.amount | amount }} {{ invoice.currency }}</td>
                <td>
                  <div
                    v-if="invoice.status"
                    class="status"
                    :class="{ warning: invoice.status !== 'charged' }">
                    {{ invoice.status }}
                  </div>
                </td>
                <td>
                  <IconButton
                    @click="download(invoice.id)"
                    class="small"
                    icon="download">
                    Download invoice
                  </IconButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import groupBy from "lodash/groupBy";
import moment from "moment";
export default {
  data: function () {
    return {
      invoicesList: [],
    };
  },

  apollo: {
    invoicesList: {
      query: gql`
        query InvoicesListQuery {
          invoicesList {
            amount
            createdAt
            currency
            id
            periodFrom
            periodTo
            status
          }
        }
      `,
    },
  },

  props: {},

  mounted() {},

  methods: {
    download(invoiceId) {
      console.log("downloading", invoiceId);
      window.location.href = `${process.env.VUE_APP_AXIOS_ENDPOINT}/invoice/pdf/${invoiceId}`;
    },
  },

  computed: {
    invoicesListByYear() {
      return groupBy(this.invoicesList, (invoice) =>
        moment(invoice.periodFrom).year()
      );
    },
  },

  filters: {
    periodName(d) {
      return moment(d).format("MMMM D, YYYY");
    },
    amount(val) {
      return Number(val / 100).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.InvoiceHistory {
  h4 {
    opacity: 0.5;
    padding-left: 1px;
  }

  .container {
    padding: 1em;
  }

  .panel {
    padding: 0 !important;
  }

  .status {
    background-color: var(--dark-seafoam);
    width: 100%;
    color: var(--white);
    border-radius: 100px;
    padding-left: 1em;
    padding-right: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;

    &.warning {
      background-color: var(--pinkish-red);
    }
  }

  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .text-bold {
    font-weight: bold;
  }
}
</style>
